import moment from 'moment'

export default class PayoutService {

  failureMessages = {
    account_closed: 'A conta bancária foi encerrada.',
    account_frozen: 'A conta bancária foi congelada.',
    bank_account_restricted: 'A conta bancária possui restrições quanto ao tipo ou quantidade de transferências permitidas (geralmente conta poupança ou não corrente).',
    bank_account_unusable: 'O banco informou que a conta bancária não pode ser utilizada.',
    bank_ownership_changed: 'A conta bancária não é mais válida porque mudou de titularidade.',
    could_not_process: 'O banco não conseguiu processar esta transferência.',
    debit_not_authorized: 'Débito não autorizado.',
    declined: 'O banco recusou esta transferência. Entre em contato com o banco antes de tentar novamente.',
    incorrect_account_holder_address: 'O banco informou que o endereço do titular da conta está incorreto.',
    incorrect_account_holder_name: 'O banco informou que o nome do titular da conta está incorreto.',
    incorrect_account_holder_tax_id: 'O banco informou que o CPF/CNPJ do titular da conta está incorreto. Verifique se não foi cadastrada uma conta PF em uma conta Stripe PJ (ou vice-versa).',
    incorrect_account_type: 'O banco informou que o tipo da conta está incorreto (normalmente deve ser corrente ou poupança).',
    insufficient_funds: 'A conta bancária não possui saldo suficiente para realizar esta transferência.',
    invalid_account_number: 'O número da conta bancária é inválido.',
    invalid_account_number_length: 'O número da conta bancária informado é muito longo.',
    invalid_currency: 'O banco não consegue processar transferências nesta moeda.',
    no_account: 'Nenhuma conta bancária foi encontrada com os dados informados.',
    unsupported_card: 'O banco não oferece mais suporte a transferências para este cartão.',
  }

  getFailureMessage(failureCode) {
    return this.failureMessages[failureCode] || null
  }

  getPayoutStatus(payoutStatus) {
    switch (payoutStatus) {
      case 'paid':
        return {
          title: 'Realizado',
        }
      case 'failed':
        return {
          title: 'Falha',
        }
      case 'canceled':
        return {
          title: 'Cancelado',
        }
      case 'in_transit':
        return {
          title: 'Em trânsito',
        }
      case 'pending':
        return {
          title: 'Aguardando',
        }
      default:
        return {
          title: 'N/A',
        }
    }
  }
  preparePayout(payout) {
    const result = {
      date: moment(payout.arrival_date).format('DD/MM/YYYY'),
      amount: payout.amount.toCurrency(),
      statusObject: this.getPayoutStatus(payout.status),
    }

    if (payout.status === 'failed' && payout.failure_code) {
      result.failureMessage = this.getFailureMessage(payout.failure_code)
    }

    return result
  }
  preparePayoutTransaction(transaction) {

    return {
      available_on: moment(transaction.available_on).format('DD/MM/YYYY'),
      net: transaction.net.toCurrency(),
    }
  }
}